// extracted by mini-css-extract-plugin
export default {"root":"j6l5HwSveW"};